export const contactEmail = 'hello@gorodeo.app';
export const contactEmailHref = `mailto:${contactEmail}`;
